import { dataUsersAll } from "actions/dataUsersAction";
import { provinsiFetchAll } from "actions/provinsiAction";
import { roleFetchAll } from "actions/roleAction";
import { AvForm, AvInput } from "availity-reactstrap-validation";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Card,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import Select, { components } from "react-select";
import {
  FORM_CONSIGNEE,
  FORM_REGULATOR,
  FORM_RESELLER,
  FORM_SHIPPER,
  FORM_SUPPLIER,
  FORM_VESSEL_OP,
} from "actions/constant";
import { kotaFetchSub } from "actions/kotaAction";

let data = [];
let isDefaultUserType = false;
let isDefaultName = false;
let isDefaultKota = false;
let isDefaultProv = false;

class DataUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 10,
      user_type_id: "",
      user_type_label: "",
      kota_id: "",
      kota_label: "",
      provinsi_id: "",
      provinsi_label: "",
      nama_perusahaan: "",
    };
    this.selectProv = this.selectProv.bind(this);
    this.selectKota = this.selectKota.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.selectUserType = this.selectUserType.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.props.provinsiFetchAll();
    this.props.roleFetchAll();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        user_type_id: this.state.user_type_id,
      };

      if (this.state.curPage === undefined) {
        data.start = this.state.start;
      } else {
        let offset = this.state.curPage * 10 - 10;
        data.start = offset;
      }

      if (prevState.provinsi_id !== "") {
        data.provinsi_id = this.state.provinsi_id;
      }

      if (prevState.kota_id !== "") {
        data.kota_id = this.state.kota_id;
      }

      if (prevState.nama_perusahaan !== "") {
        data.nama_perusahaan = this.state.nama_perusahaan;
      }

      this.props.dataUser(data);
    }
  }

  selectProv(opt) {
    if (opt) {
      this.setState({
        provinsi_id: opt.value,
        provinsi_label: opt.label,
        kota_id: "",
      });

      this.props.kotaFetchSub("get_propinsi/" + opt.value);
    } else {
      this.setState({
        provinsi_id: "",
        provinsi_label: "",
        kota_id: "",
      });
    }
  }

  selectKota(opt) {
    if (opt) {
      this.setState({
        kota_id: opt.value,
        kota_label: opt.label,
      });
    } else {
      this.setState({
        kota_id: "",
        kota_label: "",
      });
    }
  }

  selectUserType(opt) {
    if (opt) {
      this.setState({
        user_type_id: opt.value,
        user_type_label: opt.label,
      });
    } else {
      this.setState({
        user_type_id: "",
        user_type_label: "",
      });
    }
  }

  handleFilter(event, values) {
    if (this.state.user_type_id === "") {
      alert("jenis user wajib diisi");
      return;
    }

    if (this.state.user_type_id) {
      values.user_type_id = this.state.user_type_id;
      isDefaultUserType = true;
    } else {
      delete values.user_type_id;
      isDefaultUserType = false;
    }

    if (this.state.provinsi_id) {
      values.provinsi_id = this.state.provinsi_id;
      isDefaultProv = true;
    } else {
      delete values.provinsi_id;
      isDefaultProv = false;
    }

    if (this.state.kota_id) {
      values.kota_id = this.state.kota_id;
      isDefaultKota = true;
    } else {
      delete values.kota_id;
      isDefaultKota = false;
    }

    if (values.nama_perusahaan) {
    } else {
      delete values.nama_perusahaan;
    }

    values.length = this.state.perPage;
    values.start = 0;

    this.props.dataUser(values);
  }

  handleClick(e) {
    this.setState({ curPage: e });
  }

  render() {
    let defaultValues = {
      user_type_id: this.state.user_type_id,
      user_type_label: this.state.user_type_label,
      provinsi_id: this.state.provinsi_id,
      provinsi_label: this.state.provinsi_label,
      kota_id: this.state.kota_id,
      kota_label: this.state.kota_label,
      nama_perusahaan: this.state.nama_perusahaan,
    };

    const prevPage = parseInt(this.props.dataUsers?.currentPage) - 1;
    const nextPage = parseInt(this.props.dataUsers?.currentPage) + 1;

    let curPage = this.props.dataUsers?.currentPage;
    let minPage = Number(curPage) - 2;
    let maxPage = Number(curPage) + 2;

    const pages = [];
    const totalPages = this.props.dataUsers?.pageTotal;

    for (let index = 1; index <= totalPages; index++) {
      if (pages.indexOf(index) == -1) {
        pages.push(index);
      }
    }

    const { user_type_id } = this.state.user_type_id;
    const defaultValueUserType = {
      label: defaultValues.user_type_label,
      value: defaultValues.user_type_id,
    };

    const { provinsi_id } = this.state.provinsi_id;
    const defaultValueProv = {
      label: defaultValues.provinsi_label,
      value: defaultValues.provinsi_id,
    };

    const { kota_id } = this.state.kota_id;
    const defaultValueKota = {
      label: defaultValues.kota_label,
      value: defaultValues.kota_id,
    };

    const customStyle = {
      control: (base) => ({
        ...base,
        border: 0,
        color: "red",
        backgroundColor: "#edf3ff",
        boxShadow: "none",
      }),
    };

    const DropdownIndicator = (props) => {
      return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            <i
              className="fa fa-caret-down"
              style={{ color: "#224B98" }}
              aria-hidden="true"
            ></i>
          </components.DropdownIndicator>
        )
      );
    };

    const Control = ({ children, ...props }) => (
      <components.Control {...props} style={{ borderRadius: "25px" }}>
        {props.selectProps.id === "user_type_id" ? (
          <i
            className="fa fa-user"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          ></i>
        ) : props.selectProps.id === "nama_perusahaan" ? (
          <i
            className="fa fa-building-o"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          ></i>
        ) : props.selectProps.id === "provinsi_id" ? (
          <i
            className="fa fa-map-marker"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          ></i>
        ) : (
          props.selectProps.id === "kota_id" && (
            <i
              className="fa fa-map-pin"
              style={{ color: "#224B98" }}
              aria-hidden="true"
            ></i>
          )
        )}{" "}
        {children}
      </components.Control>
    );

    const IconOption = (props) => (
      <components.Option {...props}>{props.data.label}</components.Option>
    );

    return (
      <div
        style={{
          backgroundColor: "#3B6ECE",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Container>
          <Card
            style={{
              position: "relative",
              top: -70,
              padding: "0 28px",
              borderRadius: 30,
            }}
          >
            <AvForm
              onValidSubmit={this.handleFilter}
              model={defaultValues}
              style={{
                backgroundColor: `rgba(${109}, ${157}, ${249}, ${0.12})`,
                margin: "34px 0 10px",
                padding: "30px 30px 14px",
                borderRadius: 10,
              }}
            >
              <Row>
                {this.props.roleIsSuccess && (
                  <Col md="12" lg="">
                    <FormGroup>
                      <Select
                        name="user_type_id"
                        value={user_type_id}
                        isClearable
                        placeholder="-- Jenis User --"
                        defaultValue={
                          isDefaultUserType ? defaultValueUserType : false
                        }
                        onChange={this.selectUserType}
                        options={this.props.roles.data.filter(
                          (role) => role.id < 6 && role.id !== 4
                        )}
                        id="user_type_id"
                        inputId="input_user_type_id"
                        instanceId="instance_user_type_id"
                        styles={customStyle}
                        components={{
                          Control,
                          Option: IconOption,
                          DropdownIndicator,
                          IndicatorSeparator: () => null,
                        }}
                      />
                    </FormGroup>
                  </Col>
                )}
                <hr className="vertical d-none d-lg-block" />
                {this.props.provinsiIsSuccess && (
                  <Col md="12" lg="">
                    <FormGroup>
                      <Select
                        name="provinsi_id"
                        value={provinsi_id}
                        isClearable
                        placeholder="-- Pilih Provinsi --"
                        defaultValue={isDefaultProv ? defaultValueProv : false}
                        onChange={this.selectProv}
                        options={this.props.provinsis.data}
                        id="provinsi_id"
                        inputId="input_provinsi_id"
                        instanceId="instance_provinsi_id"
                        styles={customStyle}
                        components={{
                          Control,
                          Option: IconOption,
                          DropdownIndicator,
                          IndicatorSeparator: () => null,
                        }}
                      />
                    </FormGroup>
                  </Col>
                )}
                <hr className="vertical d-none d-lg-block" />
                {this.props.kotaIsSuccess && (
                  <Col md="12" lg="">
                    <FormGroup>
                      <Select
                        name="kota_id"
                        value={kota_id}
                        isClearable
                        placeholder="-- Pilih Kota --"
                        defaultValue={isDefaultKota ? defaultValueKota : false}
                        onChange={this.selectKota}
                        options={this.props.kotas.data}
                        id="kota_id"
                        inputId="input_kota_id"
                        instanceId="instance_kota_id"
                        styles={customStyle}
                        components={{
                          Control,
                          Option: IconOption,
                          DropdownIndicator,
                          IndicatorSeparator: () => null,
                        }}
                      />
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row>
                <Col md="12" lg="">
                  <FormGroup>
                    <InputGroup>
                      {/* <InputGroupAddon addonType="prepend">
                        <InputGroupText
                          style={{ backgroundColor: "transparent" }}
                        >
                          <i
                            className="fa fa-map-pin"
                            style={{ color: "#224B98" }}
                            aria-hidden="true"
                          ></i>
                        </InputGroupText>
                      </InputGroupAddon> */}
                      <AvInput
                        type="text"
                        name="nama_perusahaan"
                        placeholder="-- Nama Perusahaan --"
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                      ></AvInput>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <hr className="vertical d-none d-lg-block" />
                <Col>
                  <FormGroup className="form-actions">
                    <Button
                      type="submit"
                      size="md"
                      color="primary"
                      className=" btn-brand mr-1 mb-1"
                    >
                      <i className="fa fa-search"></i> <span>Cari</span>
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </AvForm>

            {/* {this.props.dataUserGetSuccess && ( */}
            <Table responsive striped bordered>
              <thead>
                <tr>
                  <th>Nama Perusahaan</th>
                  <th>Jenis User</th>
                  <th>Provinsi</th>
                  <th>Kabupaten</th>
                  <th>No Telepon</th>
                </tr>
              </thead>
              <tbody>
                {!this.props.dataUserGetSuccess &&
                  !this.props.dataUserGetLoading && (
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                        colSpan="5"
                      >
                        Cari Data
                      </td>
                    </tr>
                  )}

                {this.props.dataUserGetSuccess &&
                  this.props.dataUsers.data.length === 0 && (
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                        colSpan="5"
                      >
                        Data tidak ditemukan
                      </td>
                    </tr>
                  )}

                {this.props.dataUserGetLoading && (
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                      colSpan="5"
                    >
                      Loading...
                    </td>
                  </tr>
                )}

                {this.props.dataUserGetError && (
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                      colSpan="5"
                    >
                      Silahkan mencoba beberapa saat lagi, pastikan anda
                      terkoneksi dengan internet.
                    </td>
                  </tr>
                )}

                {this.props.dataUserGetSuccess &&
                  this.props.dataUsers.data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.nama_perusahaan}</td>
                      <td>{item.usertype}</td>
                      <td>{item.provinsi}</td>
                      <td>{item.kota}</td>
                      <td>{item.telp}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            <Pagination>
              {this.props.dataUsers?.hasPrev ? (
                <PaginationItem>
                  <PaginationLink
                    previous
                    tag="button"
                    onClick={(e) => this.handleClick(1)}
                  >
                    First Page
                  </PaginationLink>
                </PaginationItem>
              ) : null}

              {this.props.dataUsers?.hasPrev ? (
                <PaginationItem>
                  <PaginationLink
                    previous
                    tag="button"
                    onClick={(e) => this.handleClick(prevPage)}
                  >
                    Prev
                  </PaginationLink>
                </PaginationItem>
              ) : null}

              {pages.map((item, index) => {
                let actived = false;
                if (curPage === undefined) {
                  curPage = 1;
                }

                if (item == curPage) {
                  actived = true;
                }

                if (item >= minPage && item <= maxPage) {
                  return (
                    <PaginationItem active={actived} key={index}>
                      <PaginationLink
                        tag="button"
                        onClick={(e) => this.handleClick(item)}
                      >
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  );
                }
              })}

              {this.props.dataUsers?.hasNext ? (
                <PaginationItem>
                  <PaginationLink
                    next
                    tag="button"
                    onClick={(e) => this.handleClick(nextPage)}
                  >
                    Next
                  </PaginationLink>
                </PaginationItem>
              ) : null}

              {this.props.dataUsers?.hasNext ? (
                <PaginationItem>
                  <PaginationLink
                    next
                    tag="button"
                    onClick={(e) => this.handleClick(totalPages)}
                  >
                    Last Page
                  </PaginationLink>
                </PaginationItem>
              ) : null}
            </Pagination>

            {this.props.dataUsers?.pageTotal > 0 && (
              <p>
                Page: {this.props.dataUsers?.currentPage} of{" "}
                {this.props.dataUsers?.pageTotal}
              </p>
            )}
          </Card>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataUsers: state.dataUsers.dataUsers,
    dataUserGetSuccess: state.dataUsers.dataUserGetSuccess,
    dataUserGetLoading: state.dataUsers.dataUserGetLoading,
    dataUserGetError: state.dataUsers.dataUserGetError,

    roles: state.roles.roles,
    roleIsSuccess: state.roles.roleGetSuccess,
    roleHasError: state.roles.roleGetError,
    roleIsLoading: state.roles.roleGetLoading,

    provinsis: state.provinsis.provinsis,
    provinsiIsSuccess: state.provinsis.provinsiGetSuccess,
    provinsiHasError: state.provinsis.provinsiGetError,
    provinsiIsLoading: state.provinsis.provinsiGetLoading,

    kotas: state.kotas.kotas,
    kotaIsSuccess: state.kotas.kotaGetSuccess,
    kotaHasError: state.kotas.kotaGetError,
    kotaIsLoading: state.kotas.kotaGetLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dataUser: (data) => dispatch(dataUsersAll(data)),
    roleFetchAll: () => dispatch(roleFetchAll()),
    provinsiFetchAll: () => dispatch(provinsiFetchAll()),
    kotaFetchSub: (data) => dispatch(kotaFetchSub(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataUser);
